import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Col, Label, FormGroup } from 'reactstrap';
import ErrorGif from '../../../../../Assets/images/Error.gif';
import { GetRegularExpresions } from '../../../../../action/EmployeeAction';
import { ResetPassword } from '../../../../../action/Administration/administrationAction';
import { sendSingleAmplitudeEvent } from 'amplitude/amplitude';

export const ErrorText = {
    PwdErrorInfo : "The new password does not comply with security requirements.  Use a more secure password or contact your system administrator.",
    InvalidErrorInfo: "Error: You left necessary fields blank or entered invalid values. Review and correct any fields with \"!\" next to them.",
    RecentPassword: "Error: Please choose a new password that has not been used recently. Contact your system administrator for the number of passwords the system retains in the password history list.",
    MailFailedToSend: "Error: An error has occurred when sending email notification of the password change. The password was updated successfully."
}

function PasswordReset({ResetModalPopup, UserName, MailAddress, UserID}) {
    
    /*state declaration*/
    const [Error, setError] = useState(false);
    const [ErrorDetails, setErrorText] = useState(ErrorText.PwdErrorInfo);
    const [passwordError, setPasswordError] = useState(false);
    const [emailError, setEmailError] = useState(false);
    const [IsResetdisable, setResetDisable] = useState(false);
    const [IsEmailChecked, setMailState] = useState(MailAddress !== "" ? false : true);

    /*ref declaration*/
    const inputRef = useRef({});
    const initialRender = useRef(true);

    /*map state to props*/
    const label = useSelector(state => state.CulturalLabelsRootReducer.SystemAdmin_LabelsBasedOnPreference);
    const EnsemblePwdPolicy = useSelector(state => state.EmployeeRootReducer);
    const ResetErrorMessage = useSelector(state => state.InstallationsRootReducer.ResetPasswordErrorMsg);

    /*map dispatch to props*/
    const dispatch = useDispatch();

    /*calling methods after component mounts*/
    useEffect(() => {
        dispatch(GetRegularExpresions());
    }, []);

    /* To achieve the async, await functionality */
    useEffect(() => {
        if(!initialRender.current) { //To avoid to call this method on intial render 
            CheckErrorMessage();
        } else {
            initialRender.current = false;
        }
    }, [ResetErrorMessage]); 

    const CheckErrorMessage = () => {
        if(ResetErrorMessage !== ""){
            if(ResetErrorMessage === "NoError"){
                sendSingleAmplitudeEvent("TS on TC Reset Password")
                ResetModalPopup();
            }  
            else {
                setError(true);
                setResetDisable(false);
                if(ResetErrorMessage === "PasswordUpdateFailed")
                    setErrorText(ErrorText.RecentPassword);
                else
                    setErrorText(ErrorText.MailFailedToSend);
            }
        }
    }

    const OnPasswordReset = async() => {
        setError(false);
        setEmailError(false);
        setPasswordError(false);
        var IsvalidPwd = true, IsvalidEmail = true;
        var l_PassWord = inputRef.current['password'].value;
        var l_EmailAddress = inputRef.current['EmailAddr'].value;
        IsvalidPwd = ValidatePassword(l_PassWord);
        IsvalidEmail = inputRef.current['NotifyUser'].checked === true ? ValidateEmail(l_EmailAddress) : true;

        if(IsvalidPwd && IsvalidEmail){
            var l_Data = {
                "userId" : UserID,
                "emailAddress" : inputRef.current['NotifyUser'].checked === true ? l_EmailAddress : "",
                "password": l_PassWord
            }
            setResetDisable(true);
            await dispatch(ResetPassword(l_Data));
        }
        else
            setError(true);
    }

    const ValidatePassword = (lPassword) => {
        var RegExpPasswordPattern = EnsemblePwdPolicy.RegularExpression[1];
        var RegexpPasswordLength = EnsemblePwdPolicy.RegularExpression[0];
        var RegexpPasswordDuplicatePattern = /([a-z])\1/i;
        var RegexpPasswordDuplicateAllowed =EnsemblePwdPolicy.RegularExpression[3];
        var RegexpPasswordLogOnNameForPasswordAllowed = EnsemblePwdPolicy.RegularExpression[2];
        if(lPassword === ""){
            setPasswordError(true);
            setErrorText(ErrorText.InvalidErrorInfo);
            return false;
        }else{
            if(!lPassword.match(RegExpPasswordPattern) || !lPassword.match(RegexpPasswordLength)){ //not matching password policy
                setPasswordError(true);
                setErrorText(ErrorText.PwdErrorInfo);
                return false;
            }else if(RegexpPasswordDuplicateAllowed === "False" && lPassword.match(RegexpPasswordDuplicatePattern)){ //repeating characters in password
                setPasswordError(true);
                setErrorText(ErrorText.PwdErrorInfo);
                return false;
            }else if(RegexpPasswordLogOnNameForPasswordAllowed === "False" && UserName !== "" && lPassword.toLowerCase().indexOf(UserName.toLowerCase()) !== -1){ //password cannot contain user id
                setPasswordError(true);
                setErrorText(ErrorText.PwdErrorInfo);
                return false;
            }else{
                return true;
            }
        }
    }

    const ValidateEmail = (l_EmailAddress) => {
        let RegExpEmail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (l_EmailAddress === "" || (l_EmailAddress !== "" && !l_EmailAddress.match(RegExpEmail))) {
            setEmailError(true);
            setErrorText(ErrorText.InvalidErrorInfo);
            return false;
        } else {
            return true;
        }
    }

    return(
        <div>
            <FormGroup row style={{"padding-left":"5px","padding-top":"5px"}}>
                <Col sm={{ size: 10 }}>
                    <h2 className="dbd_sub_heading">{label['UserChangeLog.TransactionType.98.Text'] !== undefined ? label['UserChangeLog.TransactionType.98.Text'] : "Reset Password"}</h2>
                </Col>
            </FormGroup>
            <FormGroup>
                <Col sm={{ size: 12 }}>
                    <Label className="ResetLbl">Enter a custom password. If Notify User by E-mail is selected, the new password will be sent to the E-mail shown in the textbox.  Click Save to apply the new password.</Label>
                </Col>
            </FormGroup>
            { 
                Error ? <FormGroup>
                    <Col sm={{ size: 12 }}>
                        <p className="error_msg ResetLbl" style={{ paddingBottom: "20px" }}><img src={ErrorGif} alt="Trane Logo" style={{"padding-right":"5px"}} />{ErrorDetails}</p>
                    </Col>
                </FormGroup> : ""
            }
            <FormGroup row style={{"padding-left":"15px"}}>
                <Col sm={{ size: 4 }}>
                    <Label className="ResetLbl">New Password</Label>
                </Col>
                <Col sm={{ size: 6 }}>
                    <input ref={el => inputRef.current['password'] = el} type="text" className="ResetInput" />
                    <span className="ErrorMark" hidden={!passwordError}>!</span>
                </Col>
            </FormGroup>
            <FormGroup row style={{"padding-left":"15px"}}>
                <Col sm={{ size: 4 }}>
                    <p className="ResetLbl"><input ref={el => inputRef.current['NotifyUser'] = el} type="checkbox" onChange={() => setMailState(!IsEmailChecked)} defaultChecked={MailAddress !== "" ? true : false} style={{"margin-right":"10px"}} />
                    Notify User by E-mail</p>
                </Col>
                <Col sm={{ size: 6 }}>
                    <input ref={el => inputRef.current['EmailAddr'] = el} type="text" defaultValue={MailAddress} disabled={IsEmailChecked} className="ResetInput" />
                    <span className="ErrorMark" hidden={!emailError}>!</span>
                </Col>
            </FormGroup>
            <FormGroup>
                <Col sm={{ size: 10 }}>
                    <Button className="btn-gray btn-md" onClick={ResetModalPopup}>Cancel</Button>
                    <Button className="btn-success btn-md" onClick={()  => OnPasswordReset()} disabled={IsResetdisable}>Save</Button>
                </Col>
            </FormGroup>
        </div>
    );
} 

export default PasswordReset;